import { useState } from "react";


export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const API = "https://happyhorizon.co.in/api";
  const login = async () => {
    setLoading(true);

    try {
      const res = await fetch(`${API}/login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });

      const data = await res.json();

      if (data.success) {
        setSuccess(true);
        // Store login status in localStorage
        localStorage.setItem('isLoggedIn', 'true');

        // small delay for premium feel
        setTimeout(() => {
          window.location.href = "/upload";
        }, 1500);
      } else {
        alert("Invalid email or password");
      }
    } catch (err) {
      alert("Server not reachable");
    }

    setLoading(false);
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h2>Welcome Back</h2>
        <p style={styles.sub}>Login to continue</p>

        <input
          style={styles.input}
          placeholder="Email"
          onChange={e => setEmail(e.target.value)}
        />

        <input
          style={styles.input}
          type="password"
          placeholder="Password"
          onChange={e => setPassword(e.target.value)}
        />

        <button style={styles.button} onClick={login} disabled={loading}>
          {loading ? "Checking..." : "Login"}
        </button>

        {success && (
          <div style={styles.success}>
            ✅ Login successful
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    height: "100vh",
    display: "grid",
    placeItems: "center",
    background: "linear-gradient(135deg,#667eea,#764ba2)"
  },
  card: {
    background: "#fff",
    padding: 40,
    borderRadius: 14,
    width: 320,
    textAlign: "center",
    boxShadow: "0 20px 40px rgba(0,0,0,.2)"
  },
  sub: {
    color: "#666",
    marginBottom: 20
  },
  input: {
    width: "100%",
    padding: 12,
    marginBottom: 14,
    borderRadius: 8,
    border: "1px solid #ddd"
  },
  button: {
    width: "100%",
    padding: 12,
    borderRadius: 8,
    border: "none",
    background: "#667eea",
    color: "#fff",
    fontWeight: 600,
    cursor: "pointer"
  },
  success: {
    marginTop: 16,
    color: "green",
    fontWeight: 600
  }
};
